export default __webpack_public_path__ + "static/media/playlist-icon.d20071d8.png";